/* Package block add to cart script */
document.addEventListener("DOMContentLoaded", () => {
  // Element Class
  const packageInputClass = ".package-block__products";
  const packageButtonClass = ".package-block__button.package-block__button-add";

  // DOM Elements
  const packageInputArray = Array.from(
    document.querySelectorAll(packageInputClass)
  );
  const packageButtonArray = Array.from(
    document.querySelectorAll(packageButtonClass)
  );

  // Set Button Event Listeners
  if (packageButtonArray) {
    const rootURL = "https://little-big-friends.com/";
    const currentPath = window.location.href.replace(rootURL, "");
    const pathLocale = currentPath.split("/")[0];

    let endpointLocale = "";
    let endpointCart = "/cart";

    console.log("Theme.js: Current Path: ", currentPath);
    console.log("Theme.js: Current Path: ", pathLocale);

    if (pathLocale.includes("?")) {
      endpointLocale = pathLocale.split("?")[0];
    } else if (
      pathLocale !== "" &&
      pathLocale !== "collections" &&
      pathLocale !== "products" &&
      pathLocale !== "pages"
    ) {
      endpointLocale = "/" + pathLocale;
    }

    const endpoint = endpointLocale + endpointCart;

    console.log("Theme.js: Endpoint Locale: ", endpointLocale);
    console.log("Theme.js: Endpoint: ", endpoint);

    packageButtonArray.forEach((button) => {
      button.addEventListener("click", () => {
        // Get Package Data

        const currentIndex = packageButtonArray.indexOf(event.target);
        const packageData =
          packageInputArray[currentIndex].getAttribute("data-products");

        if (!packageData) return;

        setButtonDisabled(event.target, true);

        const productIDs = packageData
          .split(",")
          .filter((package) => package != "" && package != ",");

        const queryData = { items: [] };

        productIDs.forEach((id) => {
          queryData.items.push({
            id: id,
            quantity: 1,
          });
        });

        console.log("q", endpoint);

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(queryData),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Products Added", data);
          })
          .then((error) => console.log(error))
          .finally(() => {
            // window.location.href = endpointCart;
             window.location.href = endpoint;
          });
      });
    });

    function setButtonDisabled(button, state) {
      button.setAttribute("aria-disabled", state);
      button.disabled = state;
    }
  }
});
